import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useSelector } from 'react-redux';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { ConfirmButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import { getSelectedDuration } from '../BoostCoreModal/redux/selectors';
import BoostIllustration from '../BoostIllustration';

interface Props {
  onRequestClose: () => void;
}

const BoostSuccessModal: React.FC<Props> = ({ onRequestClose }) => {
  const { t } = useTranslation();
  const isBoostV2 = useFlag('boost_v2');
  const selectedDuration = useSelector(getSelectedDuration) || 1;
  const duration = selectedDuration * 24;

  return (
    <MessageModal
      isOpen
      variant="vertical"
      image={<BoostIllustration />}
      onRequestClose={onRequestClose}
      title={t('boostDeviation.successModal.title')}
      message={
        isBoostV2
          ? t('boostDeviation.successModal.messageWithDuration', { duration })
          : t('boostDeviation.successModal.message')
      }
      footerButtons={[
        <ConfirmButton key="confirm" onClick={onRequestClose}>
          {t('common.gotIt')}
        </ConfirmButton>,
      ]}
    />
  );
};
BoostSuccessModal.displayName = 'BoostSuccessModal';

export default BoostSuccessModal;
